import M from 'materialize-css';

export function updateFile(name, id, id_div_btn, file_name) {
  let file_input = document.createElement('input');
  file_input.type = 'file';
  file_input.name = name;
  file_input.id = id;
  file_input.onchange = function() {
      M.toast({html: '<span>File '+file_name+' modificato</span>'});
  };

  let label = document.createElement('label');
  label.htmlFor = file_input.id;
  label.className = 'btn';
  label.innerHTML = 'Cambia';

  let icon = document.createElement('i');
  icon.className = 'material-icons';
  icon.innerHTML = 'repeat';

  label.appendChild(icon);

  let div_btn = document.getElementById(id_div_btn);
  div_btn.appendChild(file_input);
  div_btn.appendChild(label);
  div_btn.removeChild(div_btn.childNodes[1]);

  label.click();
}

export function addFiles(name, base_id) {
  var files_input = document.querySelector("input[name^='"+name+"[']");
  let empty_files = false;

  if (!files_input) {
      empty_files = true;
  } else {
      if ((files_input.files == null) || (files_input.files.length === 0)) {
          empty_files = true;
      }
  }

  let deleteInput = document.getElementById('delFiles_'+base_id);

  if (empty_files)
  {
      let actual_numfiles = parseInt(deleteInput.getAttribute('data-filesnum',0))+1;
      deleteInput.setAttribute('data-filesnum', actual_numfiles);
      createRow('files', name, base_id, actual_numfiles);
  }
  else
  {
    alert('Prima aggiungi tante righe quanti i documenti che vuoi caricare, poi procedi a sceglierli. Ricarica la pagina per ricominciare');
  }
}

export function createRow(container, name, id, files_number) {
  var row = document.createElement('div');
  row.className = 'row asdform_files';
      var div_image = document.createElement('div');
          div_image.className = 'col s6';
          var image = document.createElement('div');
              image.className = 'col asd_filetype';
              image.id = id+'_doc'+files_number+'_image';
          div_image.appendChild(image);
      var div_btn = document.createElement('div');
      div_btn.className = 'col s6';
          var file_input = document.createElement('input');
              file_input.type = 'file';
              file_input.name = name+'['+files_number+']';
              file_input.id = id+'_doc'+files_number;
              file_input.addEventListener( 'change', onInputFileSelect );
          var label = document.createElement('label');
              label.htmlFor = file_input.id;
              label.className = 'btn';
              label.innerHTML = 'Carica file';
              var icon = document.createElement('i');
                  icon.className = 'material-icons';
                  icon.innerHTML = 'file_upload';
              label.appendChild(icon);
      div_btn.appendChild(file_input);
      div_btn.appendChild(label);
  row.appendChild(div_image);
  row.appendChild(div_btn);

  var div_container = document.getElementById(container+'_'+id);
  div_container.appendChild(row);
}

export function deleteFile(file, id) {
  var toDelete = document.getElementById('delFiles_'+id);
  let actual_values;
  if (toDelete.value.length === 0)
    actual_values = [];
  else
    actual_values = toDelete.value.split(/,/);
  var length = actual_values.length;
  for(var i = 0; i < length; i++) {
    if(actual_values[i] === file)
      return;
  }
  actual_values.push(file);
  toDelete.value = actual_values.toString();

  let row = document.getElementById('row_'+id+'_'+file);
  row.className = row.className += ' deleted';
  M.toast({html: '<span>File '+file+' cancellato</span>'});
}

export function onInputFileSelect( e ) {
  var label	 = document.getElementById(this.id+'_image');
  var fileName = e.target.value.split( '\\' ).pop();
  var ext = fileName.split('.').pop();
  if( fileName )
  {
    var span = document.createElement('span');
    span.innerHTML = 'Caricato '+fileName;
    span.className = 'asd_filetype';
    label.parentNode.appendChild(span);
  }
  var image = '/media/com_asdgest/images/filetype/_blank.png';
  if (ext !== undefined && ext !== '')
  {
    if (ext === 'pdf')
      image = '/media/com_asdgest/images/filetype/pdf.png';
    else if (ext === 'doc' || ext === 'docx')
      image = '/media/com_asdgest/images/filetype/doc.png';
    else if (ext === 'zip')
      image = '/media/com_asdgest/images/filetype/zip.png';
  }

  label.style.backgroundImage = "url('"+image+"')";
}

export function deleteUpdateFile (file_name, name, id) {
  deleteFile(file_name, id);
  updateFile(name, id+'_'+file_name, id+'_'+file_name+'_divbtn', file_name);
}

/*
Old way xD - rewritten in index_baubau.js as doc_ready(...)
jQuery(window).on('ready', function($) {
  Array.prototype.forEach.call( inputs, function( input )
  {
  	input.addEventListener( 'change', onInputFileSelect );
  });
  old way xD

});
 */

export function Init() {
    let inputs = document.querySelectorAll('.asdform_files input');
    inputs.forEach(x => {
        x.addEventListener('change', onInputFileSelect);
    });
}
